import { App } from "realm-web";

const APP_ID = "live-portal-api-bsnmg"; // replace with your App ID

const realmApp = new App({
    id: APP_ID,
});

export default realmApp;
